import React from 'react'
import { compose } from 'recompose'
import withTemporaryForm from 'hocs/bases/withTemporaryForm'
import { withSortableCollection } from 'hocs/bases/withSortableCollection'
import EditableText from 'components/forms/bases/EditableText'
import { Button, Grid, Dropdown, Icon } from 'semantic-ui-react'
import styled from 'styled-components'

const DeleteSectionWrapper = styled(Grid.Column)`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
`

const FormList = withSortableCollection({
  dataSet: {},
  buttonProps: {
    style: { marginLeft: 12, marginTop: 10 },
  },
  buttonLabel: 'More Condition',
})(
  ({
    item: {
      name,
      value,
      condition,
    },
    index,
    onDeleteByIndex,
    onUpdateItemByIndex,
  }) => {
    const conditionOptions = [
      {
        key: 'is',
        value: 'is',
        text: 'is in',
      },
      {
        key: 'is_not',
        value: 'is_not',
        text: 'is not in',
      },
    ]
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={4}>
            <Grid.Row>
              <EditableText
                value={name}
                placeholder={'type attr (ex. brand)'}
                onDelete={() => onDeleteByIndex(index)}
                onChange={(val) => onUpdateItemByIndex(index, val, 'name')}
                hasRemoveItem={false}
              />
            </Grid.Row>
          </Grid.Column>
          <Grid.Column width={3}>
            <Grid.Row>
              <Dropdown
                placeholder="condition"
                selection
                fluid
                value={condition}
                onChange={(_, val) => onUpdateItemByIndex(index, val.value, 'condition')}
                options={conditionOptions}
              />
            </Grid.Row>
          </Grid.Column>
          <Grid.Column width={4}>
            <Grid.Row>
              <EditableText
                value={value}
                placeholder={'id list (ex. 8)'}
                onDelete={() => onDeleteByIndex(index)}
                onChange={(val) => onUpdateItemByIndex(index, val, 'value')}
                hasRemoveItem={false}
              />
            </Grid.Row>
          </Grid.Column>
          <DeleteSectionWrapper width={1}>
            <Grid.Row>
              <Icon
                size={'large'}
                color={'red'}
                name="trash"
                style={{ cursor: 'pointer' }}
                onClick={() => onDeleteByIndex(index)}
              />
            </Grid.Row>
          </DeleteSectionWrapper>
        </Grid.Row>
      </Grid>
    )
  },
)

const FormConditionList = compose(
  withTemporaryForm(),
)(
  ({
    value,
    onChange,
    onSubmit,
  }) => (
    <div>
      <FormList
        collection={value}
        onUpdate={onChange}
      />
      <Button style={{ marginTop: 20 }} fluid onClick={onSubmit}>Submit</Button>
    </div>
  ),
)

FormConditionList.propTypes = {}
FormConditionList.defaultProps = {}

export default FormConditionList




// WEBPACK FOOTER //
// ./src/components/forms/FormConditionList.js